<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        classTabContent="pl-12 pr-12"
                        class="mt-3"
                        :data="tabData"
                        activeKey="completed_jobs">
                    <template slot="gofixTab:completed_jobs">
                        <gofix-card class="mb-0" fullContent>
                             <jobs job_status="ask"></jobs>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import jobs from "./emails";
    export default {
        name: 'joblist-all',
        components: {
            jobs
        },
        data() {
            return{
                tabData:[
                    {
                        key: "inbox",
                        title: "Inbox",
                        active: true,
                        link: `/case/emails/inbox`
                    },
                    {
                        key: "outbox",
                        title: "outbox",
                        active: true,
                        link: `/case/emails/outbox`
                    },
                    // {
                    //     key: "due_jobs",
                    //     title: "All",
                    //     active: false,
                    //     link: `/case/emails/all`
                    // },
                    {
                        key: "completed_jobs",
                        title: "ASK",
                        active: false,
                        link: `/case/emails/ask`
                    },
                    {
                        key: "expired_jobs",
                        title: "CSTL",
                        active: false,
                        link: `/case/emails/cstl`
                    },
                    {
                        key: "all_jobs",
                        title: "QP",
                        active: false,
                        link: `/case/emails/qp`
                    },
                ]
            }
        },
        created() {},
        methods: {}
    }
</script>
